/* global axios */
import ApiClient from './ApiClient';

// Tareas comerciales (E03): trabajo de una persona sobre un contacto. No envían
// mensajes. Contrato del backend (PR #264):
// - index/summary aceptan scope (mine|all|unassigned), status, due
//   (overdue|today|upcoming|undated), pipeline_id, assigned_user_id, task_type,
//   contact_id y page. summary usa el mismo scope y filtros que la lista.
// - update, complete y cancel exigen lock_version: si quedó vieja, 409
//   task_conflict con la tarea actual en `task`.
// - complete/cancel repetidos devuelven 200 (already_completed/cancelled); sobre
//   una tarea terminal del otro tipo, 422 task_terminal.
class CommercialTasksAPI extends ApiClient {
  constructor() {
    super('commercial_tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  complete(id, lockVersion) {
    return axios.post(`${this.url}/${id}/complete`, {
      lock_version: lockVersion,
    });
  }

  cancel(id, { lockVersion, reason } = {}) {
    return axios.post(`${this.url}/${id}/cancel`, {
      lock_version: lockVersion,
      ...(reason ? { cancellation_reason: reason } : {}),
    });
  }

  events(id) {
    return axios.get(`${this.url}/${id}/events`);
  }
}

export default new CommercialTasksAPI();
